import { createMongoAbility } from '@casl/ability'

// DAY-37: 'administer' = the API's Manage access. CASL's own 'manage' means "every action".
export type Actions = 'create' | 'read' | 'update' | 'delete' | 'administer' | 'manage'

// Permission modules from the API (Participants, CarePlans, Centers, ...); 'all' = every subject.
export type Subjects = string

export interface Rule { action: Actions; subject: Subjects }

export const ability = createMongoAbility<[Actions, Subjects]>()
